module.exports = __webpack_public_path__ + "static/image3-ddc561616d505b7e760b6125c55c9d8a.jpg";